import { DateTime, Info } from "luxon";
import { useContext, useEffect, useState } from "react"
import Chart from 'react-apexcharts'
import { FeatureContext } from "../../../Context";
import { currency, lang, useBfGlobals } from "../../../Utils";

const Charts = () => {

  const globals = useBfGlobals();
  
  const context = useContext(FeatureContext);
  const orderCurrency =  context?.orders?.data.pop().currency;

  const [donuts, setDonuts] = useState();
  const [bar, setBar] = useState();

  const barChartOptions = {
    chart: {
      sparkline: { enabled: true }
    }
  }

  const donutsOption = {
    legend: false,
    fill: { colors: [] },
    labels: [],
    tooltip: {
      custom: function ({ series, seriesIndex, dataPointIndex, w }) {
        return '<div style="background: #212121; color: #fff; padding: 5px 15px; font-size: 14px">'
          + '<span>'
          + w.globals.labels[seriesIndex]
          + ': '
          + currency(w.globals.series[seriesIndex], orderCurrency)
          + '</span>'
          + '</div>'
      }
    },
    plotOptions: {
      pie: {
        donut: {
          labels: {
            show: true,
            value: {
              formatter: (value) => currency(value, orderCurrency)
            },
            total: {
              show: true,
              label: lang('Total'),
              formatter: (value) => currency(value.config.series.reduce((sum, value) => sum + value, 0), orderCurrency)
            }
          }
        }
      }
    }
  }

  useEffect(() => {

    const dataDonuts = {
      series: [],
      labels: [],
      options: {},
      colors: []
    }
    Object.entries(context?.orders?.aggregate.status).forEach(item => {
      if (item[0] !== 'total') {
        dataDonuts.labels = [...dataDonuts.labels, lang(context?.orders?.order_status[item[0]])];
        dataDonuts.series = [...dataDonuts.series, item[1].value];
        dataDonuts.colors = [...dataDonuts.colors, lang(context?.orders?.order_status_colors[item[0]])];
      }
    });
    dataDonuts.options = {
      ...donutsOption,
      labels: dataDonuts.labels,
      fill: { colors: dataDonuts.colors }
    };
    setDonuts(dataDonuts);
    const dataBar = {
      series : {
        name : lang('Amount'),
        data : []
      },
      categories : []
    }
    
    Object.entries(context?.orders?.aggregate.month).forEach(item => {
      if (item[0] !== 'total') {
        const date = DateTime.fromISO(`${item[0]}-01`);
        dataBar.categories = [
          ...dataBar.categories, 
          date.setLocale(globals.get('locale').split('_')[0]).toFormat('yyyy LLLL') + ', ' + lang('Quantity') + ': ' + item[1].count
        ];
        dataBar.series.data = [...dataBar.series.data, item[1].value.toFixed(2)]
      }
    });
    setBar(dataBar);

  }, [context?.orders?.aggregate.status]);

  return (
    <div className="bf-graph-wrapper">
      <div className="bf-graph-status">
        {(!!donuts) ? <Chart options={donuts.options} series={donuts.series} labels={donuts.labels} type="donut" width="100%" /> : null}
      </div>
      <div className="bf-graph-value">
        <div className="bf-graph-title">
          <label>{lang('Total Value')}</label>
          <span>{currency(context?.orders.aggregate?.month?.total.value)}</span>
        </div>
        <div className="bf-graph-title">
          <label>{lang('Total Quantity')}</label>
          <span>{context?.orders.aggregate?.month?.total.count}</span>
        </div>
        {(!!bar) ?
          <Chart
            options={{
              ...barChartOptions,
              xaxis: {
                labels: {
                  formatter: function (value, timestamp, number) {
                    return value
                  }
                }, 
                categories: bar.categories,
              }
            }}
            series={[bar.series]}
            type="bar"
            width="100%"
          /> : null
        }
      </div>
    </div>)
}

export default Charts;